<template>
  <div class="celender-cell-content" >
    <template v-if="data" >
      <div :style="{visibility: all>0?'visible':'hidden'}">
        <div>正職</div>
        <div>{{staffs || 0}}</div>
        <div>人</div>
      </div>
      <div :style="{visibility: all>0?'visible':'hidden'}">
        <div>PT</div>
        <div>{{pts || 0}}</div>
        <div>人</div>
      </div>
      <div :style="{visibility: all>0?'visible':'hidden'}">
        <div>總數</div>
        <div>{{all || 0}}</div>
        <div>人</div>
      </div>
    </template>
    <hr v-if="data&&result.length>0&&all>0">
    <template  v-if="data&&result.length>0">
    <div v-for="(kpi, r) in kpis" :key="r" class="cell2">
      <div>{{kpi.slice(0, 2)}}</div>
      <div>{{getInt(kpi)}}</div>
    </div>
    </template>
  </div>
</template>

<script>
export default {
  props: ['index', 'date', 'data', 'kpis'],
  data () {
    return {
      wdy: ['日', '一', '二', '三', '四', '五', '六', '日']
    }
  },
  computed: {
    data2 () {
      const data = JSON.parse(JSON.stringify(this.data))
      delete data.result
      return data
    },
    result () {
      return this.data.result
    },
    staffs () {
      if (this.data) {
        return Array.from(new Set([].concat(...Object.values(this.data2).map(e => e.staffs.map(a => a._id))))).length
      } else {
        return 0
      }
    },
    pts () {
      if (this.data) {
        return Array.from(new Set([].concat(...Object.values(this.data2).map(e => e.pts.map(a => a._id))))).length
      } else {
        return 0
      }
    },
    all () {
      if (this.data) {
        return this.pts + this.staffs
      } else {
        return 0
      }
    }
  },
  methods: {
    getInt (kpi) {
      const f = this.result.find(e => e.name === kpi)
      if (f && f.total) {
        return this.formatDollarInt(f.total)
      } else {
        return '$0'
      }
    }
  }

}
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.celender-cell-content {
    flex-direction: column;
    padding-block: 5px 15px;
    gap: 5px;
    padding-inline: 20px;
    &>div:not(.cell2){
      width: 100%;
      height: 27px;
      display: grid;
      grid-template-columns: 60px 1fr 1fr;
      align-items: center;
      justify-content: space-between;
      &>div:nth-child(1), &>div:nth-child(3) {
        color: #848484;
        font-weight: 400;
        font-size: 14px;
        line-height: 27px;
        letter-spacing: 0.1em;
      }
      &>div:nth-child(2) {
        color: #000000;
        font-weight: 700;
        font-size: 18px;
        line-height: 27px;
        text-align: center;
        letter-spacing: 0.1em;

      }
    }
    &>div.cell2 {
      width: 100%;
      height: 27px;
      display: grid;
      grid-template-columns: 40px 1fr;
      &>div:nth-child(1) {
        color: #848484;
        font-weight: 400;
        font-size: 14px;
        line-height: 27px;
        letter-spacing: 0.1em;
      }
      &>div:nth-child(2) {
        color: var(--color-number);
        font-weight: 700;
        font-size: 18px;
        line-height: 27px;
        text-align: end;
        letter-spacing: 0.1em;

      }

    }
}
</style>
